import { Component, ChangeDetectionStrategy, output, signal, ChangeDetectorRef, HostListener, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MasterService } from '@/src/services/master.service';
import { Constants } from '@/src/helpers/constants';
import { AuthenticationService } from '@/src/services/authentication.service';
import { PasswordModule } from 'primeng/password';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { M_STORE } from "../../models/M_STORE"
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ForgotPass } from '../forgot-pass/forgot-pass'
import { SidebarService } from '@/src/services/sidebar.service';
import { WebSocketService } from '@/src/services/webSocket.service';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, TranslateModule, PasswordModule, InputTextModule, CheckboxModule, TableModule, DialogModule, CommonModule, ForgotPass],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  isLogin: boolean = true;
  loginSuccess = output<void>();
  checked_remember: boolean = false;
  checked_auto: boolean = false;
  showStore: boolean = false;
  isAdminLogin: boolean = false;
  submit: boolean = false;
  P_PAGEROW = Constants.P_PAGEROW_POPUP;
  param = {
    P_HQ_CD: "",
    P_USE_YN: "Y",
    P_STR_CD: "",
    P_STR_NM: "",
    P_PAGEINDEX: 1,
    P_PAGEROW: this.P_PAGEROW
  }

  bodyAuthenUsername = {
    username: "", password: "", remember: false, isAdmin: false
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification(event: BeforeUnloadEvent) {
    if (this.isAdminLogin) {
      this.auth.logout();
    }
  }

  constructor(private masterService: MasterService, private auth: AuthenticationService, private cdr: ChangeDetectorRef, private router: Router,
    private sidebarService: SidebarService, private webSocket: WebSocketService) {
  }

  ngOnInit() {
    if (this.auth.currentUser()) {
      this.webSocket.initWebSocket();
      this.loginSuccess.emit();
    }
    else {
      const id = localStorage.getItem(Constants.CurrentId);
      this.bodyAuthenUsername.username = id ? id : '';
      this.checked_remember = id ? true : false;
    }
  }

  onLogin() {
    localStorage.removeItem(Constants.CartTemp);
    this.submit = true;
    this.bodyAuthenUsername.remember = this.checked_auto;
    if (this.bodyAuthenUsername.password.length == 0 || this.bodyAuthenUsername.username.length == 0) return;
    this.auth.login(this.bodyAuthenUsername, this.checked_auto).subscribe((res: any) => {
      if (res.isOK) {
        const user = res?.result?.dataRes;
        const actionLogin = () => {
          if (this.checked_remember) localStorage.setItem(Constants.CurrentId, this.bodyAuthenUsername.username);
          else localStorage.removeItem(Constants.CurrentId);
        }

        if (user.isAdmin) {
          this.isAdminLogin = true;
          let userEncrypt = Constants.encryptWithKey(JSON.stringify(user), this.auth.getPrivateKeyUser());
          if (this.checked_auto) localStorage.setItem(Constants.CurrentUser, userEncrypt);
          else sessionStorage.setItem(Constants.CurrentUser, userEncrypt);
          this.getStore();
          this.showStore = true;
          actionLogin();
          this.cdr.detectChanges();
        }
        else {
          let userEncrypt = Constants.encryptWithKey(JSON.stringify(user), this.auth.getPrivateKeyUser());
          if (this.checked_auto) localStorage.setItem(Constants.CurrentUser, userEncrypt);
          else sessionStorage.setItem(Constants.CurrentUser, userEncrypt);
          actionLogin();
          this.sidebarService.setMenu('/dashboard')
          this.router.navigate(['/dashboard']);
          this.loginSuccess.emit();
        }
      }
      else {
        this.masterService.showError(Constants.showError(res.errorMessages))
      }
      this.submit = false;
    });
  }

  stores = new Array<M_STORE>();

  selectStore(store: M_STORE) {
    const user = this.auth.currentUser();
    user.stR_CD = store.stR_CD;
    let userEncrypt = Constants.encryptWithKey(JSON.stringify(user), this.auth.getPrivateKeyUser());
    if (this.checked_auto) localStorage.setItem(Constants.CurrentUser, userEncrypt);
    else sessionStorage.setItem(Constants.CurrentUser, userEncrypt);
    localStorage.setItem(Constants.IsAdminLogin, 'Y');
    localStorage.setItem(Constants.strNm, store.stR_NM);
    this.showStore = false;
    this.sidebarService.setMenu('/dashboard')
    this.router.navigate(['/dashboard']);
    localStorage.removeItem(Constants.CartTemp)
    this.loginSuccess.emit();
  }
  @ViewChild('tb') table!: any;
  totalCnt = 0;
  getStore(P_PAGEINDEX: number = 1, isNextPage: boolean = false) {
    const hqCd = this.auth.getHQCD();
    if (hqCd != '') {
      this.param.P_STR_CD = this.param.P_STR_NM.length > 7 ? this.param.P_STR_NM.slice(0, 7) : this.param.P_STR_NM;
      this.param.P_HQ_CD = hqCd;
      this.param.P_PAGEINDEX = P_PAGEINDEX;
      //SP_POP_STR_LIST
      this.masterService.excute_sp('6a839a25-298d-11f1-9014-00155d001e03', this.param).subscribe((res: any) => {
        if (res?.isOK) {
          const newData = res?.result?.dataRes[1]?.rows || [];
          this.totalCnt = res?.result?.dataRes[0]?.rows[0]?.totalcnt
          this.stores = new M_STORE().getAllStores(newData);
          if (this.table && !isNextPage) {
            this.table.reset();
          }
          this.cdr.detectChanges();
        }
      })
    }
  }

  loadPage(event: any) {
    const page = (event.first / event.rows) + 1;
    this.getStore(page, true);
  }
}
